import React from 'react';

import {
	ConfirmacaoServicoDesbloqueio,
	FormOwnerData,
} from 'pages/DetranCrv/components/pages/ServicosDeVeiculos/ConfirmacaoServicoDesbloqueio';

import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';

import { formatDateISOWithOutUTC } from 'utils/genericFunctions';

const BloqueioDiversosBloqueioJudicialConfirmacao = () => {
	const { registraSolicitacoes } = useSelector(
		(state: ApplicationState) => state.api.detranCrv.solicitarDocumentos,
	);

	const formOwnerData: FormOwnerData = {
		typeService: 'DESB_JUDICIAL',
		plate:
			registraSolicitacoes?.requestData?.request?.placa?.toString().trim() ||
			'',
		cpfcnpj:
			registraSolicitacoes?.requestData?.request?.cpfCnpj?.toString().trim() ||
			'',
		renavam:
			registraSolicitacoes?.requestData?.request?.renavam?.toString().trim() ||
			'',
		requestDate:
			(registraSolicitacoes?.requestData?.requestDate &&
				formatDateISOWithOutUTC(
					registraSolicitacoes.requestData.requestDate.toString().trim(),
					true,
				)) ||
			'',
		formYear: registraSolicitacoes?.responseData?.ano?.toString().trim() || '',
		formNumber:
			registraSolicitacoes?.responseData?.ficha?.toString().trim() || '',
	};

	return <ConfirmacaoServicoDesbloqueio formOwnerData={formOwnerData} />;
};

export default BloqueioDiversosBloqueioJudicialConfirmacao;
